import React, { useState } from 'react';
import { FaMapMarkerAlt, FaUsers, FaClock, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../Destination/Destination.css';
import DestinationPost from './DestinationPost';
import Connect from '../Connect/Connect';
import { Link } from 'react-router-dom';
import Ftour from './Ftour';

const featuredData = [
  // Beach (2 additional)
  {
    id: 1,
    img: '/t1.avif',
    title: 'Tropical Paradise Escape',
    desc: 'Relax on pristine white sand beaches with crystal clear waters in this island getaway.',
    rating: 4.8,
    reviews: 24,
    days: '5 Days - 4 Nights',
    people: '1–12',
    location: 'Maldives Islands',
    price: '₹42,999',
    originalPrice: '₹49,999',
    offer: '14% Off',
    tags: ['Luxury', 'Beach'],
    category: 'Beach'
  },
  {
    id: 2,
    img: '/t2.avif',
    title: 'Coastal Adventure Package',
    desc: 'Explore hidden coves and enjoy water sports along beautiful coastal landscapes.',
    rating: 4.5,
    reviews: 18,
    days: '4 Days - 3 Nights',
    people: '2–10',
    location: 'Goa, India',
    price: '₹18,500',
    originalPrice: null,
    offer: null,
    tags: ['Adventure', 'Water Sports'],
    category: 'Beach'
  },
  {
    id: 10,
    img: '/d.avif',
    title: 'Caribbean Beach Retreat',
    desc: 'Experience the vibrant culture and stunning beaches of the Caribbean islands.',
    rating: 4.7,
    reviews: 31,
    days: '7 Days - 6 Nights',
    people: '2–8',
    location: 'Jamaica',
    price: '₹55,000',
    originalPrice: '₹60,000',
    offer: '8% Off',
    tags: ['All-Inclusive', 'Beach'],
    category: 'Beach'
  },
  {
    id: 11,
    img: '/d0.avif',
    title: 'Australian Coastal Tour',
    desc: 'Discover the stunning beaches of Australia\'s Gold Coast with surfing lessons included.',
    rating: 4.6,
    reviews: 22,
    days: '6 Days - 5 Nights',
    people: '2–6',
    location: 'Gold Coast, Australia',
    price: '₹48,500',
    originalPrice: null,
    offer: null,
    tags: ['Surfing', 'Beach'],
    category: 'Beach'
  },

  // Adventure (2 additional)
  {
    id: 3,
    img: '/d1.avif',
    title: 'Mountain Trekking Expedition',
    desc: 'Challenge yourself with this high-altitude trek through breathtaking mountain landscapes.',
    rating: 4.9,
    reviews: 36,
    days: '8 Days - 7 Nights',
    people: '4–12',
    location: 'Himalayas, India',
    price: '₹32,000',
    originalPrice: '₹36,000',
    offer: '11% Off',
    tags: ['Trekking', 'Adventure'],
    category: 'Adventure'
  },
  {
    id: 12,
    img: '/d2.avif',
    title: 'Amazon Jungle Adventure',
    desc: 'Explore the Amazon rainforest with guided jungle treks and river expeditions.',
    rating: 4.8,
    reviews: 19,
    days: '5 Days - 4 Nights',
    people: '2–8',
    location: 'Amazon, Brazil',
    price: '₹38,000',
    originalPrice: '₹42,000',
    offer: '10% Off',
    tags: ['Jungle', 'Wildlife'],
    category: 'Adventure'
  },
  {
    id: 13,
    img: '/d3.avif',
    title: 'Desert Safari Experience',
    desc: 'Experience the thrill of dune bashing and overnight camping in the desert.',
    rating: 4.5,
    reviews: 27,
    days: '3 Days - 2 Nights',
    people: '2–10',
    location: 'Rajasthan, India',
    price: '₹15,500',
    originalPrice: null,
    offer: null,
    tags: ['Desert', 'Camping'],
    category: 'Adventure'
  },

  // Family (2 additional)
  {
    id: 4,
    img: '/t3.avif',
    title: 'Family Beach Vacation',
    desc: 'Perfect family-friendly resort with activities for all ages and beautiful ocean views.',
    rating: 4.7,
    reviews: 32,
    days: '6 Days - 5 Nights',
    people: '2–8',
    location: 'Phuket, Thailand',
    price: '₹35,000',
    originalPrice: '₹39,000',
    offer: '10% Off',
    tags: ['Family', 'Resort'],
    category: 'Family'
  },
  {
    id: 14,
    img: '/d4.avif',
    title: 'Disneyland Package',
    desc: 'Magical family vacation to the happiest place on earth with all park passes included.',
    rating: 4.9,
    reviews: 48,
    days: '5 Days - 4 Nights',
    people: '2–6',
    location: 'Paris, France',
    price: '₹75,000',
    originalPrice: '₹82,000',
    offer: '9% Off',
    tags: ['Theme Park', 'Kids'],
    category: 'Family'
  },
  {
    id: 15,
    img: '/d5.avif',
    title: 'National Park Explorer',
    desc: 'Family-friendly wildlife safari with guided tours and comfortable accommodations.',
    rating: 4.6,
    reviews: 21,
    days: '4 Days - 3 Nights',
    people: '2–8',
    location: 'Ranthambore, India',
    price: '₹28,500',
    originalPrice: null,
    offer: null,
    tags: ['Wildlife', 'Safari'],
    category: 'Family'
  },

  // Honeymoon (formerly Romantic) (2 additional)
  {
    id: 5,
    img: '/d6.avif',
    title: 'Luxury Honeymoon Suite',
    desc: 'Exclusive couples retreat with private beach access and luxury accommodations.',
    rating: 4.9,
    reviews: 41,
    days: '7 Days - 6 Nights',
    people: '2',
    location: 'Maldives',
    price: '₹68,999',
    originalPrice: '₹75,000',
    offer: '8% Off',
    tags: ['Honeymoon', 'Luxury'],
    category: 'Honeymoon'
  },
  {
    id: 16,
    img: '/d7.avif',
    title: 'Private Island Getaway',
    desc: 'Ultimate privacy on your own private island with personal butler service.',
    rating: 5.0,
    reviews: 15,
    days: '5 Days - 4 Nights',
    people: '2',
    location: 'Seychelles',
    price: '₹92,000',
    originalPrice: '₹1,00,000',
    offer: '8% Off',
    tags: ['Private', 'Luxury'],
    category: 'Honeymoon'
  },
  {
    id: 17,
    img: '/d8.avif',
    title: 'European Honeymoon Tour',
    desc: 'Romantic tour through Paris, Venice and Santorini with luxury stays.',
    rating: 4.8,
    reviews: 29,
    days: '10 Days - 9 Nights',
    people: '2',
    location: 'Europe',
    price: '₹1,25,000',
    originalPrice: '₹1,35,000',
    offer: '7% Off',
    tags: ['Europe', 'Luxury'],
    category: 'Honeymoon'
  },

  // Wellness (2 additional)
  {
    id: 6,
    img: '/t4.avif',
    title: 'Beach Yoga Retreat',
    desc: 'Rejuvenate with daily yoga sessions on the beach and healthy organic meals.',
    rating: 4.6,
    reviews: 15,
    days: '5 Days - 4 Nights',
    people: '1–15',
    location: 'Gokarna, India',
    price: '₹22,500',
    originalPrice: null,
    offer: null,
    tags: ['Wellness', 'Yoga'],
    category: 'Wellness'
  },
  {
    id: 18,
    img: '/d9.avif',
    title: 'Ayurvedic Healing Retreat',
    desc: 'Traditional Ayurvedic treatments and therapies in a peaceful forest setting.',
    rating: 4.7,
    reviews: 18,
    days: '7 Days - 6 Nights',
    people: '1–10',
    location: 'Kerala, India',
    price: '₹32,000',
    originalPrice: '₹35,000',
    offer: '9% Off',
    tags: ['Ayurveda', 'Detox'],
    category: 'Wellness'
  },
  {
    id: 19,
    img: '/d10.avif',
    title: 'Meditation & Mindfulness',
    desc: 'Learn meditation techniques from masters in the Himalayas.',
    rating: 4.9,
    reviews: 12,
    days: '5 Days - 4 Nights',
    people: '1–8',
    location: 'Dharamshala, India',
    price: '₹18,500',
    originalPrice: null,
    offer: null,
    tags: ['Meditation', 'Spiritual'],
    category: 'Wellness'
  },

  // Island (2 additional)
  {
    id: 7,
    img: '/d11.avif',
    title: 'Island Hopping Tour',
    desc: 'Discover multiple islands with daily boat trips to the best snorkeling spots.',
    rating: 4.4,
    reviews: 27,
    days: '4 Days - 3 Nights',
    people: '4–12',
    location: 'Andaman Islands',
    price: '₹31,000',
    originalPrice: '₹35,000',
    offer: '11% Off',
    tags: ['Island', 'Snorkeling'],
    category: 'Island'
  },
  {
    id: 20,
    img: '/d12.avif',
    title: 'Luxury Private Island',
    desc: 'Exclusive access to a private island with premium amenities and services.',
    rating: 4.9,
    reviews: 14,
    days: '5 Days - 4 Nights',
    people: '2–6',
    location: 'Fiji',
    price: '₹85,000',
    originalPrice: '₹95,000',
    offer: '11% Off',
    tags: ['Private', 'Luxury'],
    category: 'Island'
  },
  {
    id: 21,
    img: '/d13.avif',
    title: 'Greek Islands Cruise',
    desc: 'Explore the beautiful Greek islands with this all-inclusive cruise package.',
    rating: 4.7,
    reviews: 33,
    days: '7 Days - 6 Nights',
    people: '2–8',
    location: 'Greece',
    price: '₹78,000',
    originalPrice: '₹85,000',
    offer: '8% Off',
    tags: ['Cruise', 'Island'],
    category: 'Island'
  },

  // Camping (2 additional)
  {
    id: 8,
    img: '/t7.avif',
    title: 'Beachside Camping Experience',
    desc: 'Sleep under the stars right on the beach with all necessary amenities provided.',
    rating: 4.3,
    reviews: 19,
    days: '2 Days - 1 Night',
    people: '1–6',
    location: 'Konkan Coast, India',
    price: '₹8,999',
    originalPrice: null,
    offer: null,
    tags: ['Camping', 'Adventure'],
    category: 'Camping'
  },
  {
    id: 22,
    img: '/d14.avif',
    title: 'Mountain Camping Retreat',
    desc: 'Experience camping at high altitude with breathtaking mountain views.',
    rating: 4.6,
    reviews: 16,
    days: '3 Days - 2 Nights',
    people: '2–8',
    location: 'Himalayas, India',
    price: '₹12,500',
    originalPrice: '₹14,000',
    offer: '11% Off',
    tags: ['Trekking', 'Camping'],
    category: 'Camping'
  },
  {
    id: 23,
    img: '/d15.avif',
    title: 'Wilderness Survival Camp',
    desc: 'Learn survival skills while camping in the wilderness with expert guides.',
    rating: 4.5,
    reviews: 11,
    days: '4 Days - 3 Nights',
    people: '2–10',
    location: 'Nagaland, India',
    price: '₹15,000',
    originalPrice: null,
    offer: null,
    tags: ['Adventure', 'Survival'],
    category: 'Camping'
  },

  // Sports (2 additional)
  {
    id: 9,
    img: '/t8.avif',
    title: 'Surfing Adventure Camp',
    desc: 'Learn to surf from professional instructors at prime surfing locations.',
    rating: 4.7,
    reviews: 13,
    days: '3 Days - 2 Nights',
    people: '1–8',
    location: 'Kovalam, India',
    price: '₹14,500',
    originalPrice: '₹16,000',
    offer: '9% Off',
    tags: ['Surfing', 'Sports'],
    category: 'Sports'
  },
  {
    id: 24,
    img: '/d16.avif',
    title: 'Skiing Adventure Package',
    desc: 'Enjoy skiing in some of the best slopes with professional instructors.',
    rating: 4.8,
    reviews: 22,
    days: '5 Days - 4 Nights',
    people: '2–6',
    location: 'Gulmarg, India',
    price: '₹32,000',
    originalPrice: '₹35,000',
    offer: '9% Off',
    tags: ['Skiing', 'Winter'],
    category: 'Sports'
  },
  {
    id: 25,
    img: '/d17.avif',
    title: 'Scuba Diving Certification',
    desc: 'Get PADI certified while exploring beautiful coral reefs and marine life.',
    rating: 4.9,
    reviews: 18,
    days: '4 Days - 3 Nights',
    people: '1–4',
    location: 'Andaman Islands',
    price: '₹28,500',
    originalPrice: '₹32,000',
    offer: '11% Off',
    tags: ['Diving', 'Adventure'],
    category: 'Sports'
  },

  // Photography (2 additional)
  {
    id: 26,
    img: '/t9.avif',
    title: 'Beach Photography Tour',
    desc: 'Capture stunning coastal landscapes with guidance from professional photographers.',
    rating: 4.5,
    reviews: 8,
    days: '2 Days - 1 Night',
    people: '1–5',
    location: 'Puri, India',
    price: '₹12,999',
    originalPrice: null,
    offer: null,
    tags: ['Photography', 'Workshop'],
    category: 'Photography'
  },
  {
    id: 27,
    img: '/d18.avif',
    title: 'Wildlife Photography Safari',
    desc: 'Professional guided wildlife photography tour in national parks.',
    rating: 4.7,
    reviews: 14,
    days: '4 Days - 3 Nights',
    people: '1–6',
    location: 'Ranthambore, India',
    price: '₹25,000',
    originalPrice: '₹28,000',
    offer: '11% Off',
    tags: ['Wildlife', 'Photography'],
    category: 'Photography'
  },
  {
    id: 28,
    img: '/d19.avif',
    title: 'Northern Lights Photography',
    desc: 'Capture the magical northern lights with expert photography guidance.',
    rating: 4.9,
    reviews: 9,
    days: '5 Days - 4 Nights',
    people: '1–4',
    location: 'Norway',
    price: '₹65,000',
    originalPrice: '₹72,000',
    offer: '10% Off',
    tags: ['Aurora', 'Photography'],
    category: 'Photography'
  }
];

const categories = [
  'All',
  'Beach',
  'Adventure',
  'Family',
  'Honeymoon',
  'Wellness',
  'Island',
  'Camping',
  'Sports',
  'Photography'
];

const TourCard = ({ item }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className={`tour-card-d ${isHovered ? 'hovered-d' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="card-image-container-d">
        <img src={item.img} alt={item.title} className="card-img-d" />
        {item.offer && (
          <div className="offer-badge-d">
            <span>{item.offer}</span>
          </div>
        )}
        <div className="card-tags-d">
          {item.tags.map((tag, index) => (
            <span key={index} className="tag-d">{tag}</span>
          ))}
        </div>
      </div>
      
      <div className="card-content-d">
        <h3 className="card-title-d">{item.title}</h3>
        <p className="card-desc-d">{item.desc}</p>
        
        <div className="rating-container-d">
          <div className="stars-d">
            {[...Array(5)].map((_, i) => (
              <FaStar 
                key={i} 
                className={i < Math.floor(item.rating) ? 'star-filled-d' : 'star-empty-d'} 
              />
            ))}
          </div>
          <span className="rating-text-d">{item.rating} ({item.reviews} Reviews)</span>
        </div>
        
        <div className="card-details-d">
          <div className="detail-item-d">
            <FaClock className="detail-icon-d" />
            <span>{item.days}</span>
          </div>
          <div className="detail-item-d">
            <FaUsers className="detail-icon-d" />
            <span>{item.people}</span>
          </div>
        </div>
        
        <div className="location-d">
          <FaMapMarkerAlt className="location-icon-d" />
          <span>{item.location}</span>
        </div>
        
        <div className={`card-footer-d ${isHovered ? 'hovered-d' : ''}`}>
          <div className="price-container-d">
            <span className="current-price-d">{item.price}</span>
            {item.originalPrice && (
              <span className="original-price-d">{item.originalPrice}</span>
            )}
          </div>
          <Link to="/contactus">
          <button className="book-btn-d">
            Book Now
          </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

const Destination = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [currentPage, setCurrentPage] = useState(0);
  
  const filteredData = selectedCategory === 'All' 
    ? featuredData 
    : featuredData.filter(item => item.category === selectedCategory);

  const totalPages = Math.ceil(filteredData.length / 2);
  const currentData = filteredData.slice(currentPage * 2, (currentPage + 1) * 2);

  const nextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setCurrentPage(0);
  };

  return (
    <>
    <DestinationPost/>
    <div className="destinations-container-d">
      <div className="sidebar-d">
        <h2 className="sidebar-title-d">Destinations</h2>
        <div className="category-list-d">
          {categories.map((category, index) => (
            <button
              key={index}
              className={`category-btn-d ${selectedCategory === category ? 'active-d' : ''}`}
              onClick={() => handleCategoryChange(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
      
      <div className="main-content-d">
        <section className="tours-section-d">
          <div className="section-header-d">
            <p className="section-subtitle-d">
              {selectedCategory === 'All' ? 'Featured' : selectedCategory} Tours
            </p>
            <h2 className="section-title-d">
              Discover Our {selectedCategory === 'All' ? 'Most Popular' : selectedCategory} Adventures
            </h2>
            <p className="section-description-d">
              Explore breathtaking destinations with our expertly curated tours
            </p>
          </div>
          
          <div className="tours-grid-d">
            {currentData.map((item) => (
              <TourCard key={item.id} item={item} />
            ))}
          </div>
          
          {filteredData.length > 2 && (
            <div className="pagination-controls-d">
              <button 
                className={`pagination-btn-d ${currentPage === 0 ? 'disabled-d' : ''}`}
                onClick={prevPage}
                disabled={currentPage === 0}
              >
                <FaChevronLeft /> Previous
              </button>
              
              <div className="page-indicator-d">
                Page {currentPage + 1} of {totalPages}
              </div>
              
              <button 
                className={`pagination-btn-d ${currentPage === totalPages - 1 ? 'disabled-d' : ''}`}
                onClick={nextPage}
                disabled={currentPage === totalPages - 1}
              >
                Next <FaChevronRight />
              </button>
            </div>
          )}
        </section>
      </div>
    </div>
    <Connect/>
    <Ftour/>
    </>
  );
};

export default Destination;